import appConfig from 'appConfig';
import { remove } from 'data/browserStorage';
import { IES_V2_AUTH, IES_V2_AUTH_VALUE } from 'constants/constants';
import { LOCAL_STORAGE } from 'data/browserStorage/constants';

export const invalidateIesV2User = async () => {
  try {
    await fetch(`${appConfig.getIESV2URL()}/sessions/?_action=logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Something went wrong in invalidateIesV2User', error);
  } finally {
    remove(IES_V2_AUTH, LOCAL_STORAGE);
    remove(IES_V2_AUTH_VALUE, LOCAL_STORAGE);
  }
};